import React from 'react';
import { StatusBadge } from './StatusBadge';

export function DataTable({ columns, rows, emptyText = 'Nenhum dado encontrado.' }) {
  if (!rows?.length) {
    return <div className="empty-state">{emptyText}</div>;
  }

  return (
    <div className="table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={row.id || row.order_number || row.email || rowIndex}>
              {columns.map((column) => {
                const value = row[column.key];
                if (column.type === 'status') {
                  return (
                    <td key={column.key}>
                      <StatusBadge value={value} />
                    </td>
                  );
                }
                if (column.render) {
                  return <td key={column.key}>{column.render(row)}</td>;
                }
                return <td key={column.key}>{value ?? '-'}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
